var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43433 3.43427C3.74675 3.12185 4.25328 3.12185 4.5657 3.43427L8.00001 6.86858L11.4343 3.43427C11.7467 3.12185 12.2533 3.12185 12.5657 3.43427C12.8781 3.74669 12.8781 4.25322 12.5657 4.56564L9.13138 7.99995L12.5657 11.4343C12.8781 11.7467 12.8781 12.2532 12.5657 12.5656C12.2533 12.8781 11.7467 12.8781 11.4343 12.5656L8.00001 9.13132L4.5657 12.5656C4.25328 12.8781 3.74675 12.8781 3.43433 12.5656C3.12191 12.2532 3.12191 11.7467 3.43433 11.4343L6.86864 7.99995L3.43433 4.56564C3.12191 4.25322 3.12191 3.74669 3.43433 3.43427Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.330877fbe1b0318c5a572b85decab21d.svg";
export { ForwardRef as ReactComponent };